import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const RiskQuestion = ({ question, handleChange, value }) => {
  console.log("value", value);
  const { t } = useTranslation("main");
  // const [value, setValue] = useState("");

  const handleChangeVal = (event, newValue) => {
    // setValue(event.target.value);
    // console.log("event", event, event.target.value);
    console.log("newValue", newValue);

    handleChange(`risk_form_level_${question.key.split("risk_")[1]}`)(
      parseInt(newValue)
    );
  };

  return (
    <FormControl>
      <FormLabel>{t(question.pregunta)}:</FormLabel>
      <RadioGroup
        value={value}
        onChange={handleChangeVal}
        sx={{ p: 2, display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        {question.responses.map((response) => (
          <FormControlLabel
            key={response.response}
            value={response.score}
            control={<Radio />}
            label={t(response.response)}
            sx={{ alignItems: "start" }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
